export default {
  'menu.zy-hr.workbench': 'ワークベンチ',
  'menu.zy-hr.dashboard': 'HRダッシュボード',
  'menu.zy-hr.employeeCenter': '従業員センター',
  'menu.zy-hr.employeeWorkbench': 'HRワークベンチ',
  'menu.zy-hr.employee': '従業員名簿',
  'menu.zy-hr.employee.recycleBin': '従業員ごみ箱',
  'menu.zy-hr.employee.detail': '従業員詳細',
  'menu.zy-hr.me': 'マイワークスペース',
  'menu.zy-hr.laborRelations': '労務関係',
  'menu.zy-hr.employeePortalSettings': '従業員ポータル設定',
  'menu.zy-hr.onboarding': '入社予定',
  'menu.zy-hr.regularization': '正社員登用',
  'menu.zy-hr.employeeChange': '従業員異動',
  'menu.zy-hr.profileChange': 'セルフサービスプロフィール変更',
  'menu.zy-hr.employeeLifecycleAudits': 'ライフサイクル監査',
  'menu.zy-hr.certificateRequests': '証明書申請',
  'menu.zy-hr.employeeRelationsAnalysis': '従業員関係分析',
  'menu.zy-hr.employeeCenterSettings': '従業員センター設定',
  'menu.zy-hr.resignation': '退職手続き',
  'menu.zy-hr.attendanceCenter': '勤怠センター',
  'menu.zy-hr.payrollCenter': '給与センター',
  'menu.zy-hr.payroll.workbench': '給与ワークベンチ',
  'menu.zy-hr.payroll.plans': '給与体系',
  'menu.zy-hr.payroll.items': '給与項目',
  'menu.zy-hr.payroll.profiles': '従業員給与プロファイル',
  'menu.zy-hr.payroll.deductions': '控除結果',
  'menu.zy-hr.payroll.adjustments': '昇給調整',
  'menu.zy-hr.payroll.runs': '給与計算バッチ',
  'menu.zy-hr.payroll.slips': '給与台帳',
  'menu.zy-hr.socialInsuranceCenter': '社会保険センター',
  'menu.zy-hr.socialInsurance.workbench': '社会保険ワークベンチ',
  'menu.zy-hr.socialInsurance.policies': '加入プラン',
  'menu.zy-hr.socialInsurance.accounts': '加入台帳',
  'menu.zy-hr.socialInsurance.changes': '増減員管理',
  'menu.zy-hr.socialInsurance.bills': '納付台帳',
  'menu.zy-hr.performanceCenter': '評価センター',
  'menu.zy-hr.performance.cycles': '評価サイクル',
  'menu.zy-hr.performance.goals': '評価目標',
  'menu.zy-hr.performance.reviews': '評価レビュー',
  'menu.zy-hr.performance.interviews': '評価面談',
  'menu.zy-hr.performance.results': '評価結果',
  'menu.zy-hr.performance.gradeRules': '等級ルール',
  'menu.zy-hr.trainingLearningCenter': '研修学習センター',
  'menu.zy-hr.careerPlanning': 'キャリア計画',
  'menu.zy-hr.talentInventory': '人材棚卸',
  'menu.zy-hr.foundationConfig': '基礎設定',
  'menu.zy-hr.processReminder': 'フローと通知',
  'menu.zy-hr.approval': '自分の承認待ち',
  'menu.zy-hr.approvalRecords': '承認履歴',
  'menu.zy-hr.approvalAbnormalRecords': '異常承認履歴',
  'menu.zy-hr.approvalDelegates': '承認代理設定',
  'menu.zy-hr.approvalHandovers': '承認引き継ぎ',
  'menu.zy-hr.approvalInstances': '承認インスタンス',
  'menu.zy-hr.approvalTemplates': '承認テンプレート',
  'menu.zy-hr.organization.unit': '組織管理',
  'menu.zy-hr.organization.position': 'ポジション管理',
  'menu.zy-hr.organization.jobLevel': '職級管理',
  'menu.zy-hr.organization.workLocation': '勤務地',
  'menu.zy-hr.organization.employeeTag': '従業員タグ',
  'menu.zy-hr.organization.roles': 'ロール権限',
  'menu.zy-hr.organization.permissions': '権限コード管理',
  'menu.zy-hr.attendance.workbench': '勤怠ワークベンチ',
  'menu.zy-hr.attendance.shifts': 'シフトライブラリ',
  'menu.zy-hr.attendance.groups': '勤怠グループ',
  'menu.zy-hr.attendance.schedules': 'シフトカレンダー',
  'menu.zy-hr.attendance.holidayPlans': '休暇プラン',
  'menu.zy-hr.attendance.record': '勤怠記録',
  'menu.zy-hr.attendance.daily': '日次勤怠',
  'menu.zy-hr.attendance.monthly': '月次勤怠',
  'menu.zy-hr.attendance.leaveBalances': '休暇残高',
  'menu.zy-hr.attendance.leaveGrantPolicies': '休暇付与ルール',
  'menu.zy-hr.attendance.leave': '休暇申請',
  'menu.zy-hr.attendance.overtime': '残業申請',
  'menu.zy-hr.attendance.punch': '打刻修正',
  'menu.zy-hr.attendance.setting': '勤怠設定',
  'menu.zy-hr.reminder': 'HRリマインダー',
  'menu.zy-hr.systemUpdates': 'システム更新',
  'menu.login': 'ログイン',
  'menu.account.center': 'アカウントセンター',
  'menu.account.workbench': 'ワークベンチに戻る',
  'menu.account.tenantManagement': '企業管理',
  'menu.account.logout': 'ログアウト',
};
